const users = {
  name: "name",
  email: "email"
};

export default users;
